import '../style.css';

const RetryErrorResponse = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='error-response'>
            <p>Verification Failed</p>
    <div className='description workday-retry-error'>
        Something went wrong! 
        It looks like you were unable to complete the CLEAR verification successfully. 
        We’re sending you a new link to your personal email to try again. 
        <br/> <br/> Here are some helpful tips to consider for a successful verification.
        <ul>
            <li>Disconnect from VPN</li>
            <li>Remove glasses and hats</li>
            <li>Hold the phone still</li>
            <li>Take photos in a room with good lighting</li>
            <li>No paper IDs</li>
        </ul>

    </div>
    </div>
            </div>
            </div>
    </div>

    )
    
};

export default RetryErrorResponse;